import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { InsurancePage } from '../booking/insurance-page';
import { useFunnelBoot } from '../booking/lib/boot';

/** Step 2 of the funnel (MASTER_PLAN M5.4, M5.7). */
export const Route = createFileRoute('/insurance')({
  component: InsuranceRoute,
});

function InsuranceRoute() {
  const navigate = useNavigate();
  useFunnelBoot('insurance');

  return (
    <InsurancePage
      onContinue={() => {
        void navigate({ to: '/payment' });
      }}
    />
  );
}
